import { __decorate, __metadata, __param } from "tslib";
import { Directive, Inject, Input } from 'angular-ts-decorators';
var DynamicPageSizeDirective = (function () {
    function DynamicPageSizeDirective($window) {
        this.$window = $window;
        this.desktopPageSize = 0;
        this.mobilePageSize = 0;
    }
    DynamicPageSizeDirective.prototype.ngOnInit = function () {
        this.$window.addEventListener('resize', this.resizeHandler.bind(this), false);
    };
    DynamicPageSizeDirective.prototype.ngOnDestroy = function () {
        this.$window.removeEventListener('resize', this.resizeHandler);
    };
    DynamicPageSizeDirective.prototype.resizeHandler = function () {
        if (!this.ngModelController) {
            return;
        }
        var pageSize = this.$window.innerWidth < 768 ? this.mobilePageSize : this.desktopPageSize;
        if (this.ngModelController.$viewValue !== pageSize) {
            this.ngModelController.$setViewValue(Number(pageSize));
        }
    };
    DynamicPageSizeDirective.$inject = ['$window'];
    __decorate([
        Input('@'),
        __metadata("design:type", Object)
    ], DynamicPageSizeDirective.prototype, "desktopPageSize", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", Object)
    ], DynamicPageSizeDirective.prototype, "mobilePageSize", void 0);
    DynamicPageSizeDirective = __decorate([
        Directive({
            link: function ($scope, $element, $attributes, controllers) {
                controllers[1].ngModelController = controllers[0];
                controllers[1].resizeHandler();
            },
            require: ['ngModel', 'dynamicPageSize'],
            selector: '[dynamicPageSize]',
        }),
        __param(0, Inject('$window')),
        __metadata("design:paramtypes", [Object])
    ], DynamicPageSizeDirective);
    return DynamicPageSizeDirective;
}());
export { DynamicPageSizeDirective };
